module.exports = __webpack_public_path__ + "static/media/mobile_separator_05.18d0e371.webp";